import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResponsiveModule} from '@viablelogic/ngx-responsive';
import {AppResponsiveConfig} from '@shared/libraries/ngx-responsive/config/responsive.config';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ResponsiveModule.forRoot(AppResponsiveConfig)
  ],
  exports: [
    ResponsiveModule
  ]
})
export class AppResponsiveModule { }
